import { render, staticRenderFns } from "./AllApprovals.vue?vue&type=template&id=e15c26e8&scoped=true&"
import script from "./AllApprovals.vue?vue&type=script&lang=js&"
export * from "./AllApprovals.vue?vue&type=script&lang=js&"
import style0 from "./AllApprovals.vue?vue&type=style&index=0&id=e15c26e8&lang=scss&scoped=true&"
import style1 from "./AllApprovals.vue?vue&type=style&index=1&id=e15c26e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15c26e8",
  null
  
)

export default component.exports